import React from 'react';

export default function _() {
    return <>
        {/* <!-- Custom Cursor Start --> */}
        <div id="cursor-large"></div>
        <div id="cursor-small"></div>
        {/* <!-- Custom Cursor End --> */}
    </>;
}